import { useCallback, useState } from "react";

type GuardMap = Record<string, () => boolean>;

export function useWizardTabs(initial: string, guards: GuardMap) {
  const [activeTab, setActiveTab] = useState<string>(initial);

  const canActivate = useCallback((id: string) => {
    const g = guards[id];
    return g ? !!g() : false;
  }, [guards]);

  const go = useCallback((id: string) => {
    if (canActivate(id)) setActiveTab(id);
  }, [canActivate]);

  return { activeTab, canActivate, go, setActiveTab };
}
